// Legacy export format because this is used by some build-time scripts stuck in the past.
// eslint-disable-next-line import/no-commonjs
module.exports = {
    APP_NAME: 'WWHWarp',
    TW_NAME: 'TurboWarp'
};
